<div class="loader-container"><div class="loader"><div class="spiner"></div></div></div>